export default {
    brand: "TermsHub"
}
